import dynamic from 'next/dynamic';
import { HeaderBackButton } from './styled';
import { BackButtonIconEnum } from './types';
import { CloseButton } from './CloseButton';

const BackButton = dynamic(
  () => import('../../BackButton').then(mod => mod.BackButton),
  { ssr: false }
);

export const useHeaderActions = (
  icon: BackButtonIconEnum,
  onClick?: () => void,
  backButtonCypress?: string
) => {
  switch (icon) {
    case BackButtonIconEnum.Back:
      return {
        customLeftAction: (
          <HeaderBackButton
            type="button"
            data-cy={backButtonCypress}
            onClick={onClick}
            aria-label="Back"
          />
        ),
        customRightAction: null
      };
    case BackButtonIconEnum.InternalNavigationBackButton:
      return {
        customLeftAction: <BackButton />,
        customRightAction: null
      };
    default:
      return {
        customLeftAction: (
          <CloseButton
            onClick={onClick}
            backButtonCypress={backButtonCypress}
          />
        ),
        customRightAction: null
      };
  }
};
